// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Parameters<typeof PopulateCart>[0];

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

export function getValidPreferredDate(state: ApplicationState, cart: CartModel) {
    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate, requestedPickupDate },
        },
    } = state;
    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate && new Date(requestedDeliveryDate.setHours(10, 0, 0, 0))
            : cart.requestedDeliveryDate && new Date(new Date(cart.requestedDeliveryDate).setHours(10, 0, 0, 0));
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined"
            ? requestedPickupDate && new Date(requestedPickupDate.setHours(10, 0, 0, 0))
            : cart.requestedPickupDate && new Date(new Date(cart.requestedPickupDate).setHours(10, 0, 0, 0));
    return {
        requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate || null),
        requestedPickupDate: convertDateToApiFormat(tempPickupDate || null),
    };
}

export const UpdatePreferredDate = (props: HandlerType) => {
    props.cart = {
        ...props.cart,
        ...getValidPreferredDate(props.getState(), props.cart),
    };
};

export const XngPopulateCart = (props: any) => {
    const state = props.getState() as any;
    const { cartId, editedCartNotes } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart available while trying to update the current cart.");
    }

    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;
    const poNumber = state?.xCheckout?.userDataById[cartId || "current"]?.poNumber;
    const customerShipComplete = state?.xCheckout?.shipComplete;

    props.cart = {
        ...cart,
        notes,
        poNumber,
        properties: {
            ...cart.properties,
            customerShipComplete,
        }
    };
};

addToChainAfter(chain, PopulateCart, UpdatePreferredDate);
replaceInChain(chain, PopulateCart, XngPopulateCart);
